var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDesktopandcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2b2d44;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 200,
    cy: 200,
    r: 197.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_8Y6zKT",
    "data-name": "8Y6zKT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.27,94.86c18.89,0,37.78-.01,56.67,0,7.52,0,9.83,2.34,9.84,9.84.01,21.16.02,42.31.01,63.47,0,6.79-2.61,9.46-9.46,9.47-38.34.03-76.67.03-115.01,0-6.57,0-9.24-2.68-9.25-9.29-.03-21.58-.03-43.16,0-64.74,0-6.03,2.74-8.74,8.83-8.75,19.45-.04,38.91-.01,58.36-.01ZM204.32,103.49h-115.78v63.6h115.78v-63.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.07,189.53h-10.66c0-.1.06-.18.06-.28v-10.69c0-2.06-1.67-3.74-3.74-3.74h-20.16c-2.06,0-3.74,1.67-3.74,3.74v10.69c0,.1.05.19.06.28h-10.66c-2.06,0-3.74,1.67-3.74,3.74v2.74c0,2.06,1.67,3.74,3.74,3.74h48.84c2.06,0,3.74-1.67,3.74-3.74v-2.74c0-2.06-1.67-3.74-3.74-3.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "H5Db4Z"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.41,245.97c1.34-14.5,7.7-25.6,21.24-31.64,15.43-6.89,32.88-2.02,42.96,11.95,1.74,2.41,3.01,3.87,6.52,3.27,18.17-3.1,32.35,7.38,34.99,25.47.11.76.29,1.5.48,2.46,2.75.48,5.48.7,8.05,1.45,10.88,3.18,18.01,13.76,16.85,24.74-1.24,11.73-10.47,21.11-22.37,21.2-37.58.3-75.17.43-112.74,0-16.76-.2-28.74-12.16-29.73-27.77-.91-14.36,9.12-27.28,23.68-30.24,3.22-.65,6.58-.6,10.07-.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.87,273.01c-1.34,0-2.68-.44-3.81-1.35-17.29-13.94-28.31-33.71-31.01-55.65-.41-3.33,1.96-6.36,5.29-6.77,3.35-.4,6.36,1.96,6.77,5.29,2.31,18.79,11.76,35.72,26.58,47.67,2.61,2.11,3.02,5.93.91,8.54-1.2,1.49-2.96,2.26-4.74,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.13,211.61c-3.36,0-6.08-2.72-6.08-6.08,0-29.87-18.72-57.16-46.58-67.9-3.13-1.21-4.69-4.73-3.48-7.86,1.2-3.14,4.73-4.68,7.85-3.48,32.52,12.54,54.37,44.38,54.37,79.24,0,3.36-2.72,6.08-6.08,6.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesktopandcloud);
export default __webpack_public_path__ + "static/media/Icon-Desktop and cloud.8927765e03212b1c4d0d36e59d764a05.svg";
export { ForwardRef as ReactComponent };